export const impactOccuer = (
  level: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'
) => {
  if (window.Telegram) {
    window.Telegram.WebApp.HapticFeedback.impactOccurred(level);
  }
};

export const notificationOccurred = (
  level: 'error' | 'warning' | 'success'
) => {
  if (window.Telegram) {
    window.Telegram.WebApp.HapticFeedback.notificationOccurred(level);
  }
};

export const selectionChanged = () => {
  if (window.Telegram) {
    window.Telegram.WebApp.HapticFeedback.selectionChanged();
  }
};
